// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImageCarousel_wrapper_3KiSk","carouselItem":"ImageCarousel_carouselItem_1rX0I"};